import { useTranslation } from 'react-i18next';
import Button from '../../components/Common/Button/Button';
import FixedButton from '../../components/Common/FixedButton/FixedButton';
import SuccessCheckIcon from '../../components/icons/SuccessCheckIcon';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const Success = () => {
    const { t } = useTranslation();
    const history = useHistory();

  return (
    <div
      className='payment-confirm-container '
      style={{ paddingBottom: 'calc(70px + env(safe-area-inset-bottom))' }}
    >
      <div className='success-content p-2 pt-5 mt-5'>
        <div className='text-center pb-5 mt-5'>
          <SuccessCheckIcon color={'var(--color-primary)'} size='135px' />
        </div>
        <div className='font-extra-large text-lighter-gray fw-bold pl-3 pb-2'>
          Listo!
        </div>
        <div className=' text-secondary pl-3'>Hemos procesado tu pago</div>
      </div>
    
      <FixedButton backgroundColor={'#000'}>
        <Button
          text={t('returnHome')}
          size='large'
          className={`mt-2`}
          onClick={() => history.push('/')}
          icon={true}
          typeIcon='arrow'
          iconColor='#000'
        />
      </FixedButton>
    </div>
  );
};

export default Success;
